import { useTranslation } from 'react-i18next';

import { Moon, Sun } from '@brightlocal/icons';
import { Toggle } from '@brightlocal/ui-components/toggle';

import { useTheme } from '../../hooks';

/**
 * A fixed top-right DS `Toggle` that switches dark mode on and off, docked
 * directly below the Feature Mocker trigger's slot (`top-4` + `size-14` + a
 * gap), so the two stack on local/dev. Renders wherever dark mode is
 * available — the `dark-mode-allowed` flag, resolved the same way on every
 * environment — see {@link useTheme}.
 */
export const DarkModeSwitcher = () => {
  const { t } = useTranslation();
  const { isDarkMode, isDarkModeAllowed, setIsDarkMode } = useTheme();

  if (!isDarkModeAllowed) {
    return null;
  }

  return (
    <Toggle
      ariaLabel={isDarkMode ? t('darkModeSwitcher.switchToLight') : t('darkModeSwitcher.switchToDark')}
      className="fixed top-20 right-1 z-40"
      dataHook="dark-mode-switcher"
      pressed={isDarkMode}
      size="lg"
      variant="outline"
      onPressedChange={setIsDarkMode}
    >
      {isDarkMode ? <Moon aria-hidden className="size-5" /> : <Sun aria-hidden className="size-5" />}
    </Toggle>
  );
};
